import { COMPANY } from "@/data/products";
import { Mail, Phone, MessageCircle, MapPin } from "lucide-react";

export default function TopBar() {
  return (
    <div
      data-testid="site-topbar"
      className="hidden md:block border-b border-[var(--eel-border)] bg-[var(--eel-surface)] text-xs text-zinc-400"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-9 flex items-center justify-between">
        <div className="flex items-center gap-5">
          <span className="flex items-center gap-2">
            <MapPin size={12} className="copper-text" /> {COMPANY.address},{" "}
            {COMPANY.country}
          </span>
          <a
            href={`mailto:${COMPANY.email}`}
            data-testid="topbar-email"
            className="flex items-center gap-2 hover:text-white"
          >
            <Mail size={12} className="copper-text" /> {COMPANY.email}
          </a>
        </div>
        <div className="flex items-center gap-5">
          <a
            href={`https://wa.me/${COMPANY.whatsappPrimaryDigits}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="topbar-wa-ireland"
            className="flex items-center gap-2 hover:text-white"
          >
            <MessageCircle size={12} className="text-green-500" /> WhatsApp{" "}
            {COMPANY.whatsappPrimary}
          </a>
          <a
            href={`tel:${COMPANY.phoneZambia}`}
            data-testid="topbar-phone-zm"
            className="flex items-center gap-2 hover:text-white"
          >
            <Phone size={12} className="copper-text" /> {COMPANY.phoneZambia}
          </a>
        </div>
      </div>
    </div>
  );
}
